interface ProtocolDrug {
  name: string;
  url: string;
}

interface ProtocolDrugsList {
  [key: string]: ProtocolDrug;
}

export const MEDICATIONS: ProtocolDrugsList = Object.freeze({
  Cetrotide: {
    name: 'Cetrotide',
    url: 'https://www.youtube.com/watch?v=5harTAY4oXM'
  },
  Follistim: {
    name: 'Follistim',
    url: 'https://www.youtube.com/watch?v=vVSflafBNlI'
  },
  Ganirelix: {
    name: 'Ganirelix',
    url: 'https://www.youtube.com/watch?v=1pEpcHAAAT8'
  },
  Delestrogen: {
    name: 'Delestrogen',
    url: 'https://www.youtube.com/watch?v=n694zibrbRA'
  },
  'Gonal F': {
    name: 'Gonal-f',
    url: 'https://www.youtube.com/watch?v=9LhHqmdM_M4'
  },
  'hCG Trigger IM': {
    name: 'hCG Trigger IM',
    url: 'https://www.youtube.com/watch?v=GX4Fo2cqaLo'
  },
  'hCG Trigger SQ': {
    name: 'hCG Trigger SQ',
    url: 'https://www.youtube.com/watch?v=LHcB51k8OTk'
  },
  'Lupron Down Regulation': {
    name: 'Lupron Down Regulation',
    url: 'https://www.youtube.com/watch?v=7qvKBKb1iNk'
  },
  'Lupron Trigger': {
    name: 'Lupron Trigger',
    url: 'https://www.youtube.com/watch?v=tXWeNz8wsn0'
  },
  Menopur: {
    name: 'Menopur',
    url: 'https://freedommedteach.com/eng/videos.html?play=menopur_draw_up_qcap%2Cgeneral_sq_2020'
  },
  'Microdose Lupron': {
    name: 'Microdose Lupron',
    url: 'https://www.youtube.com/watch?v=7qvKBKb1iNk'
  },
  'Microflare Lupron': {
    name: 'Microflare Lupron',
    url: 'https://www.youtube.com/watch?v=7qvKBKb1iNk'
  },
  'Novarel Trigger IM': {
    name: 'Novarel Trigger IM',
    url: 'https://www.youtube.com/watch?v=WcNyMwrZhsI'
  },
  'Novarel Trigger SQ': {
    name: 'Novarel Trigger SQ',
    url: 'https://www.youtube.com/watch?v=rfVf2AzC-yo'
  },
  'Novarel Trigger': {
    name: 'Novarel Trigger',
    url: 'https://www.youtube.com/watch?v=WcNyMwrZhsI' // Fallback to IM video for legacy DB entries
  },
  'Ovidrel Trigger': {
    name: 'Ovidrel',
    url: 'https://www.youtube.com/watch?v=DBE2SL8iwno'
  },
  'Progesterone in Oil': {
    name: 'Progesterone in Oil',
    url: 'https://www.youtube.com/watch?v=ZDxCmKBspzY'
  },
  Omnitrope: {
    name: 'Omnitrope',
    url: 'https://www.youtube.com/watch?v=daw9kRBZz0A'
  }
});
